import type { SiteLocale } from "../content/index.js";
import { Faq } from "../sections/faq.js";
import { Hero } from "../sections/hero.js";
import { OrganizerPanel } from "../sections/organizer-panel.js";
import { Split } from "../sections/split.js";
import { Album } from "./album.js";
import type { V2Content } from "./content.js";
import { Control } from "./control.js";
import { Ending } from "./ending.js";
import { Flow, type FlowVariant } from "./flow.js";
import { LiveCard } from "./live-card.js";
import { V2Nav } from "./nav.js";
import { Numbers } from "./numbers.js";
import { Studio } from "./studio.js";

export interface V2SiteProps {
  readonly content: V2Content;
  readonly locale: SiteLocale;
  readonly variant?: FlowVariant;
}

export function V2Site({ content, locale, variant }: V2SiteProps) {
  return (
    <>
      <div id="nav-root">
        <V2Nav content={content} menu={content.menu} locale={locale} />
      </div>
      <Hero content={content} aside={<LiveCard copy={content.live} wall={content.wall} />} />
      <Numbers items={content.numbers} />
      <Flow copy={content.flow} wall={content.wall} {...(variant ? { variant } : {})} />
      <Control copy={content.control} wall={content.wall} />
      <Album copy={content.album} event={content.control.event} />
      <Split
        flip
        mediaFirst
        tone="sunken"
        copy={content.organizer}
        media={<OrganizerPanel content={content} />}
      />
      <Studio copy={content.studio} flow={content.flow} wall={content.wall} />
      <div id="faq-root">
        <Faq content={content} />
      </div>
      <Ending copy={content.ending} content={content} />
    </>
  );
}
